export function determineComparisonStatus(
  exampleId: string,
  columnId: string,
  pairwiseNonBaseline: string | undefined,
  feedbackDeltas?: Record<
    string,
    { improved_examples: string[]; regressed_examples: string[] }
  >
) {
  if (!pairwiseNonBaseline || !feedbackDeltas) {
    return { isImprovement: false, isRegression: false };
  }

  const deltas = feedbackDeltas[pairwiseNonBaseline];
  const isBaselineColumn = columnId !== pairwiseNonBaseline;

  const isImprovement = deltas?.improved_examples?.includes(exampleId) ?? false;
  const isRegression = deltas?.regressed_examples?.includes(exampleId) ?? false;

  // Flip the status for baseline column
  return isBaselineColumn
    ? { isImprovement: isRegression, isRegression: isImprovement }
    : { isImprovement, isRegression };
}
